import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/modules/shared/services/common.service';

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss']
})
export class FormTimePickerComponent implements OnInit, OnDestroy {
  @Input() field: Field;
  @Input() form: FormGroup;
  private destroy$ = new Subject<void>();

  constructor (public readonly cs: CommonService) {}

  ngOnInit() {
    if (this.cs.isBrowser){
      if (this.field.minTimeDependentField) {
        this.form
        .get(this.field.minTimeDependentField)
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe((date) => {
          if (this.field.callback) this.field.callback(this.field, date);
        });
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
